export const queryKeys = {
  getMealData: 'get-meal-data',
  getAllScheduleData: 'get-all-schedule-data',
};
